import React, { PureComponent } from 'react';
import {setContextualHelp} from "actions/index.js";
import {setSelectedEnvelope} from "actions/index.js";
import {setShowLFOs, setArrangementBottomMode, setShowPianoRoll} from "actions/index.js";
import {setShowEnvelopes} from "actions/index.js";
import {ENVELOPE_TOGGLE_BUTTON} from 'constants/contextual-help.js';
import { connect } from "react-redux";

class EnvelopeToggle extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
        };
    }

    isToggled() {
        return this.props.parameter && this.props.parameter.isConnectedToEnvelope(this.props.envelope);
    }

    toggle() {
        if (!this.props.parameter.isAudioParamEnabled()) {
            this.props.parameter.enableAudioParam();
        }
        if (!this.isToggled()) {
            this.props.parameter.connectToEnvelope(this.props.envelope);
            this.props.setSelectedEnvelope(this.props.envelope.number);
            // this.showMods(true);
        } else {
            this.props.parameter.disconnectFromEnvelope(this.props.envelope);
        }
        this.setState({toggled: this.isToggled()});
    }

    onMouseOver(e) {
        e.stopPropagation();
        this.props.setContextualHelp(ENVELOPE_TOGGLE_BUTTON);
    }

    showMods(show) {
        this.props.setShowEnvelopes(true);
    }

    render() {
        let className = this.isToggled() ? ' toggled ' : '';
        let envelopeNumber = this.props.envelopes.indexOf(this.props.envelope);
        return (
            <div
              onMouseOver={(e) => this.onMouseOver(e)} 
              onMouseLeave={() => this.props.setContextualHelp(undefined)}
              onClick={() => this.toggle()}
              className={"parameter-envelope-toggle lfo-" + envelopeNumber + className}>
              {envelopeNumber + 1}
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch, props) => {
    return {
        setContextualHelp: (element) => dispatch(setContextualHelp(element)),
        setSelectedEnvelope: (envelope) => dispatch(setSelectedEnvelope(envelope)),
        setShowEnvelopes: (show) => dispatch(setShowEnvelopes(show)),
        setArrangementBottomMode: (mode) => dispatch(setArrangementBottomMode(mode)),
        setShowPianoRoll: (show) => dispatch(setShowPianoRoll(show)),
    };
}
 
export default connect(null, mapDispatchToProps)(EnvelopeToggle);
